#import "./ctct-activity.graphql"

fragment CtCtContact on ConstantContactContact {
    id
    emailAddress
    status
    openRate
    clickRate
    engagementRating
    sendsCount
    lastActivitySyncTime
    listMemberships {
        id
        name
    }
    latestActivity {
        ...CtCtActivity
    }
}
